import { AxiosInstance } from 'axios';
import {CreateBankRequest,
        UpdateBankRequest,
        UpdateBankSuccessPayload,
        BankEntityResponse,
        GetCdsCurvesSuccessPayload,
        GetClientBankAccountsSuccessPayload,
        GetCounterpartyBanksSuccessPayload,
        GetCreditRatingsSuccessPayload,
        BankEntity,
        SaveClientBankAccountRequest,
        SaveClientBankAccountSuccessPayload,
        GetCsaThresholdsParams,
        CreateCsaThresholdRequest,
        UpdateCsaThresholdRequest,
       } from '@/pages/Banks/types'
import { NewEntityValues } from '@/pages/Banks/components/FundLevelAdminTable/components/EntityModal/types';

export default class BanksAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }


//  -------------------------------
//  Banks
//  -------------------------------

async getBanks() {
    return this.client.get('v2/organizations/banks/');
  }
async createNewBank(data: CreateBankRequest) {
    return this.client.post('v2/organizations/create-bank/', data);
  }

async updateBank(data: UpdateBankRequest) {
    return this.client.post<UpdateBankSuccessPayload>('v2/organizations/update-bank/', data);
  }
async getBankEntities() {
    return this.client.get<BankEntityResponse>('v2/organizations/bank-entities/');
  }
async getCdsCurves() {
    return this.client.get<GetCdsCurvesSuccessPayload>('v2/company/get-cds-curves/');
  }
async getClientBankAccounts() {
  return this.client.get<GetClientBankAccountsSuccessPayload>(
      'v2/organizations/client-bank-accounts/'
    );
  }

async saveClientBankAccount(data: SaveClientBankAccountRequest) {
  return this.client.post<{ success: boolean; data: SaveClientBankAccountSuccessPayload }>(
    'v2/settlements/settlement-center-save-counterparty-bank-account/',
    data,
  );
}

async getCounterpartyBanks() {
  return this.client.get<GetCounterpartyBanksSuccessPayload>(
    'v2/organizations/counterparty-bank-accounts/'
    );
  }

  async getCreditRatings() {
  return this.client.get<GetCreditRatingsSuccessPayload>(
    'v2/organizations/credit-ratings/'
  );
}

async createNewBankEntity(data: NewEntityValues) {
    return this.client.post('v2/organizations/create-bank-entities/', data);
  }



 async updateBankEntity(entityId: number | string, data: NewEntityValues) {
    return this.client.patch(`v2/organizations/update-bank-entities/${entityId}/`, data);
  }

//  -------------------------------
//  CSA Thresholds
//  -------------------------------

async getCsaThresholds(params?: GetCsaThresholdsParams) {
    return this.client.get('v2/simulation/csa-thresholds/', { params });
  }

async createCsaThreshold(data: CreateCsaThresholdRequest) {
    return this.client.post('v2/simulation/csa-thresholds/', data);
  }

async updateCsaThreshold(id: number, data: Omit<UpdateCsaThresholdRequest, 'id'>) {
    return this.client.patch(`v2/simulation/csa-thresholds/${id}/`, data);
  }

async deleteCsaThreshold(id: number) {
    return this.client.delete(`v2/simulation/csa-thresholds/${id}/`);
  }

}